import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source), true)).call(_context8, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { memo, createContext, useMemo, useContext, useEffect, useRef } from 'react';
import { atom, selectorFamily, useRecoilValue, useSetRecoilState } from 'recoil';
import isEqual from 'react-fast-compare';
import flatten from 'flat';
import { uuid } from './utils';
import { useFormActions } from './hooks/use-form-actions';
import { MultiFormContext } from './multi-form';
import { get as _get, omit, merge, noop, memoize, isFunction } from 'lodash';
var FormContext = /*#__PURE__*/createContext({});
var FormProvider = FormContext.Provider;
var constInitialValues = {};

var cleanProps = function cleanProps(dirtyProps) {
  return omit(dirtyProps, ['touchOnChange', 'touchOnBlur', 'validateOnChange', 'validateOnBlur', 'setName']);
};

function getStateAtom(_ref) {
  var _context;

  var groupId = _ref.groupId,
      id = _ref.id;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$names = _ref2.names,
      names = _ref2$names === void 0 ? [] : _ref2$names,
      _ref2$initialValues = _ref2.initialValues,
      initialValues = _ref2$initialValues === void 0 ? constInitialValues : _ref2$initialValues;

  return atom({
    key: _concatInstanceProperty(_context = "form_".concat(groupId, "_")).call(_context, id),
    default: {
      id: id,
      names: names,
      initialValues: initialValues,
      values: initialValues,
      touched: {},
      isDirty: {},
      isValidating: {},
      isValid: {},
      errors: {},
      meta: null,
      submitCount: 0,
      isSubmitting: false
    }
  });
}

var formAtom = memoize(getStateAtom, function (_ref3) {
  var _context2;

  var groupId = _ref3.groupId,
      id = _ref3.id;
  return _concatInstanceProperty(_context2 = "".concat(groupId, "_")).call(_context2, id);
});

function getActionsAtom(_ref4) {
  var _context3;

  var groupId = _ref4.groupId,
      id = _ref4.id;
  return atom({
    key: _concatInstanceProperty(_context3 = "form_actions_".concat(groupId, "_")).call(_context3, id),
    default: {
      setName: noop,
      setFieldValue: noop,
      setValues: noop,
      setFieldTouched: noop,
      setTouched: noop,
      setFieldError: noop,
      setErrors: noop,
      setMeta: noop,
      resetField: noop,
      resetForm: noop,
      validateField: noop,
      validateForm: noop,
      submitForm: noop
    }
  });
}

var actionsAtom = memoize(getActionsAtom, function (_ref5) {
  var _context4;

  var groupId = _ref5.groupId,
      id = _ref5.id;
  return _concatInstanceProperty(_context4 = "".concat(groupId, "_")).call(_context4, id);
});
var isDirtySelector = selectorFamily({
  key: 'formIsDirty',
  get: function get(_ref6) {
    var groupId = _ref6.groupId,
        id = _ref6.id;
    return function (_ref7) {
      var _context5;

      var recoilGet = _ref7.get;

      var _recoilGet = recoilGet(formAtom({
        groupId: groupId,
        id: id
      })),
          isDirty = _recoilGet.isDirty;

      return _someInstanceProperty(_context5 = _Object$keys(flatten(isDirty))).call(_context5, function (name) {
        return _get(isDirty, name);
      });
    };
  }
});
var isChangedSelector = selectorFamily({
  key: 'formIsChanged',
  get: function get(_ref8) {
    var groupId = _ref8.groupId,
        id = _ref8.id;
    return function (_ref9) {
      var recoilGet = _ref9.get;

      var _recoilGet2 = recoilGet(formAtom({
        groupId: groupId,
        id: id
      })),
          isDirty = _recoilGet2.isDirty;

      return isDirty;
    };
  }
});
var isValidatingSelector = selectorFamily({
  key: 'formIsValidating',
  get: function get(_ref10) {
    var groupId = _ref10.groupId,
        id = _ref10.id;
    return function (_ref11) {
      var _context6;

      var recoilGet = _ref11.get;

      var _recoilGet3 = recoilGet(formAtom({
        groupId: groupId,
        id: id
      })),
          isValidating = _recoilGet3.isValidating;

      return _someInstanceProperty(_context6 = _Object$keys(flatten(isValidating))).call(_context6, function (name) {
        return !!_get(isValidating, name);
      });
    };
  }
});
var isValidSelector = selectorFamily({
  key: 'formIsValid',
  get: function get(_ref12) {
    var groupId = _ref12.groupId,
        id = _ref12.id;
    return function (_ref13) {
      var _context7;

      var recoilGet = _ref13.get;

      var _recoilGet4 = recoilGet(formAtom({
        groupId: groupId,
        id: id
      })),
          errors = _recoilGet4.errors;

      return _everyInstanceProperty(_context7 = _Object$keys(flatten(errors))).call(_context7, function (name) {
        return _get(errors, name) === null;
      });
    };
  }
});
var formSelector = selectorFamily({
  key: 'form',
  // TODO: Fix type
  // eslint-disable-next-line
  // @ts-ignore
  get: function get(_ref14) {
    var groupId = _ref14.groupId,
        id = _ref14.id,
        names = _ref14.names,
        initialValues = _ref14.initialValues;
    return function (_ref15) {
      var recoilGet = _ref15.get;
      var state = recoilGet(formAtom({
        groupId: groupId,
        id: id
      }, {
        names: names,
        initialValues: initialValues
      }));
      var isDirty = recoilGet(isDirtySelector({
        groupId: groupId,
        id: id
      }));
      var isChanged = recoilGet(isChangedSelector({
        groupId: groupId,
        id: id
      }));
      var isValidating = recoilGet(isValidatingSelector({
        groupId: groupId,
        id: id
      }));
      var isValid = recoilGet(isValidSelector({
        groupId: groupId,
        id: id
      }));

      var form = _objectSpread(_objectSpread({}, state), {}, {
        isDirty: isDirty,
        isChanged: isChanged,
        isValidating: isValidating,
        isValid: isValid
      });

      return form;
    };
  }
});

var _ReactForms = function ReactForms(_ref16) {
  var propId = _ref16.id,
      _ref16$names = _ref16.names,
      propNames = _ref16$names === void 0 ? [] : _ref16$names,
      _ref16$initialValues = _ref16.initialValues,
      propInitialValues = _ref16$initialValues === void 0 ? {} : _ref16$initialValues,
      _ref16$touchOnChange = _ref16.touchOnChange,
      touchOnChange = _ref16$touchOnChange === void 0 ? false : _ref16$touchOnChange,
      _ref16$touchOnBlur = _ref16.touchOnBlur,
      touchOnBlur = _ref16$touchOnBlur === void 0 ? true : _ref16$touchOnBlur,
      _ref16$validateOnChan = _ref16.validateOnChange,
      validateOnChange = _ref16$validateOnChan === void 0 ? false : _ref16$validateOnChan,
      _ref16$validateOnBlur = _ref16.validateOnBlur,
      validateOnBlur = _ref16$validateOnBlur === void 0 ? true : _ref16$validateOnBlur,
      propValidate = _ref16.validate,
      propHandleSubmit = _ref16.handleSubmit,
      render = _ref16.render,
      children = _ref16.children;
  var id = useRef(propId !== null && propId !== void 0 ? propId : uuid()); // TODO: Fix type
  // eslint-disable-next-line
  // @ts-ignore

  var _useContext = useContext(MultiFormContext),
      _useContext$id = _useContext.id,
      groupId = _useContext$id === void 0 ? id.current : _useContext$id;

  var form = useRecoilValue(formSelector({
    groupId: groupId,
    id: id.current,
    names: propNames,
    initialValues: propInitialValues
  }));
  var setForm = useSetRecoilState(formAtom({
    groupId: groupId,
    id: id.current
  }));
  var actions = useFormActions({
    groupId: groupId,
    id: id.current,
    validate: propValidate,
    handleSubmit: propHandleSubmit
  });
  var submitCount = form.submitCount; // If the values stored in the form atom
  // is the constant default initialValues then
  // we know the form atom has been instantiated
  // AND that it hasn't been changed programatically
  // before this ReactForms component has rendered
  // for the first time
  // In this case we synchronise the initialValues
  // passed in as a prop to the form atom

  useEffect(function () {
    setForm(function (prevForm) {
      var initialisedBeforeMount = prevForm.initialValues === constInitialValues;

      if (initialisedBeforeMount) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          initialValues: propInitialValues,
          // Merge values that have been set from
          // each field mounting with the initialValues
          values: merge({}, _valuesInstanceProperty(prevForm), propInitialValues)
        });
      }

      return prevForm;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var stable = useMemo(function () {
    return _objectSpread(_objectSpread({}, actions), {}, {
      groupId: groupId,
      id: id.current,
      touchOnChange: touchOnChange,
      touchOnBlur: touchOnBlur,
      validateOnChange: validateOnChange,
      validateOnBlur: validateOnBlur,
      initialValues: propInitialValues,
      submitCount: submitCount
    });
  }, [groupId, actions, touchOnChange, touchOnBlur, validateOnChange, validateOnBlur, propInitialValues, submitCount]);
  var volatile = useMemo(function () {
    return _objectSpread(_objectSpread({}, stable), form);
  }, [form, stable]);
  var props = useMemo(function () {
    return cleanProps(volatile);
  }, [volatile]);
  return /*#__PURE__*/React.createElement(FormProvider, {
    value: stable
  }, isFunction(children) ? children(props) : isFunction(render) ? render(props) : children);
};

export var ReactForms = /*#__PURE__*/memo(_ReactForms, isEqual);

function useReactFormsContext() {
  var stable = useContext(FormContext);
  var form = useRecoilValue(formSelector({
    groupId: stable.groupId,
    id: stable.id
  }));
  var volatile = useMemo(function () {
    return _objectSpread(_objectSpread({}, stable), form);
  }, [stable, form]);
  return useMemo(function () {
    return cleanProps(volatile);
  }, [volatile]);
}

export { useReactFormsContext, FormContext, formAtom, actionsAtom, formSelector };
export default ReactForms;